<template>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>
<script>
    export default {}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/index.vue